import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,ViewController } from 'ionic-angular';
import { PermisosProvider } from '../../providers/permisos/permisos'
import { Storage } from '@ionic/storage'
import { NUBE_AWS } from '../../config/url.servicio';

@IonicPage()
@Component({
  selector: 'page-permisos-editar',
  templateUrl: 'permisos-editar.html',
})
export class PermisosEditarPage {

  nombreCargo:string =""
  codigoCargo: string =""
  cargosId
  permisos = []
  existe: boolean= false
  datos = []

  constructor(public navCtrl: NavController, public navParams: NavParams,
             public servicio:PermisosProvider,
            public viewControllers:ViewController,
            public storages:Storage) {
    if(navParams.data.cargo){
      this.nombreCargo =navParams.data.cargo.nombreCargo
      this.codigoCargo = navParams.data.cargo.codigoCargo
      this.cargosId =  navParams.data.cargo.cargosId

      this.buscarData()


    }

  }

  buscarData(){
    this.storages.get('companiasId').then((val) => {
    this.servicio.buscarPorCompania(this.cargosId,val)
    .subscribe((data)=>{
      data = !NUBE_AWS ? data : JSON.parse(data['_body']).data[0]
      for(var k = 0;k < data.length;k++){
        this.existe = data[k].existe == 1 ? true: false;
        this.permisos.push({
          descripcion:data[k].descripcion,
          existe:this.existe,
          nombre:data[k].nombre,
          cargosId: this.cargosId,
          rutasId:data[k].rutasId,
          permisosRutasId:data[k].permisosRutasId
        })
      }


    },error=>{

    })

  })
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PermisosEditarPage');
  }

  guardar(data:any){
    for(var i=0;i < data.length;i++){
     if(data[i].existe ==true){
      this.datos = []
      let queHago = ""
      if(data[i].permisosRutasId == 0){
        queHago = "I"
      }else{
        queHago = "A"
      }
      if(queHago=="A"){
      }else{
        this.datos.push({
          cargosId:data[i].cargosId,
          rutasId:data[i].rutasId,
          name : "dataDynamicCrud",
          queHago : queHago,
          nombreTabla : "permisosRutas"
        })
        let valor = {}
        valor['cargosId'] = this.datos[0].cargosId
        valor['name'] = this.datos[0].name
        valor['queHago'] = this.datos[0].queHago
        valor['nombreTabla'] = this.datos[0].nombreTabla
        valor['rutasId'] = this.datos[0].rutasId

        this.storages.get('companiasId').then((val) => {
          valor['companiasId'] = val
          valor = JSON.stringify(valor)
          this.servicio.guardar(valor)
          .subscribe((data)=>{
          },error=>{
          })
      })
     }
    }else{
      if(data[i].permisosRutasId!=0){
        this.datos = []
        this.datos.push({
          permisosRutasId:data[i].permisosRutasId,
          name : "dataDynamicCrud",
          queHago : "E",
          nombreTabla : "permisosRutas"
        })
        let valor = []
        valor['permisosRutasId'] = this.datos[0].permisosRutasId
        valor['name'] = this.datos[0].name
        valor['queHago'] = this.datos[0].queHago
        valor['nombreTabla'] = this.datos[0].nombreTabla
        this.servicio.eliminar(valor)
        .subscribe((data)=>{
        },error=>{

        })
      }
    }
  }
  this.dismiss()
}


dismiss(){
  this.viewControllers.dismiss();
}

}



// WEBPACK FOOTER //
// ./src/pages/permisos-editar/permisos-editar.ts